import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProfilePageService } from '../services/profile-page.service';
import { Employee, Farm, FarmLocations, GetFarmImagesResponseType, GetUsersResponseType, Product, Review } from '../../models/types';
import { LoginService } from '../services/login.service';
import { UserInfo } from '../../models/types';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { FullCalendarComponent } from "../components/full-calendar/full-calendar.component";
import { MapComponent } from '../components/map/map.component';
import { MapService } from '../services/map.service';
import { FarmStatisticsPageComponent } from '../farm-statistics-page/farm-statistics-page.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faMagnifyingGlass, 
  faCow,
  faStar,
  faLocationDot,
  faLocationCrosshairs, 
  faTractor,
  faEdit, 
  faTrash, 
  faUsers, 
  faUser,
  faPlus, 
  faClipboard,
  faEnvelope,
  faMessage,
  faPhone,
  faImage,
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { MarketPageService } from '../services/market-page.service';
import { StarRatingModule } from 'angular-star-rating';
import { ProductListComponent } from '../components/product-list/product-list.component';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganisationServiceService } from '../services/organisation-service.service';

@Component({
  selector: 'app-add-farm-images-modal',
  standalone: true,
  imports: [CommonModule, 
    FormsModule, 
    FullCalendarComponent, 
    MapComponent,
    FarmStatisticsPageComponent, 
    FontAwesomeModule, 
    StarRatingModule, 
    ProductListComponent, 
    RouterModule,
    RouterOutlet],
  templateUrl: './add-farm-images-modal.component.html',
  styleUrl: './add-farm-images-modal.component.scss'
})
export class AddFarmImagesModalComponent {

  @Input() farm!: Farm; // Farm object to which the images will be added

  faMagnifyingGlass = faMagnifyingGlass;
  faCow = faCow;
  faStar = faStar;
  faLocationDot = faLocationDot;
  faLocationCrosshairs = faLocationCrosshairs;
  faTractor = faTractor;
  faEdit = faEdit;
  faTrash = faTrash;
  faUsers = faUsers;
  faUser = faUser;
  faPlus = faPlus;
  faClipboard = faClipboard;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faMessage = faMessage;
  faImage = faImage;
  imageFiles: File[] = []; // Array to hold selected image files
  previewImageSrcs: string[] = []; // Array to hold preview URLs
  
  constructor(private profilePageService: ProfilePageService,
    public activeModal: NgbActiveModal,
    private organisationService: OrganisationServiceService
  ) { }
  
addFarmImages(): void {
  if (this.imageFiles.length > 0) {
    this.profilePageService.addFarmImages(this.farm.farmID, this.imageFiles).subscribe(
      (response) => {
        console.log('Farm images added successfully:', response);
        this.activeModal.close();
        window.location.reload();
      },
      (error) => {
        console.error('Error adding farm images:', error);
      }
    );
  } else {
    alert('Please select at least one image to upload.');
  }
}

  onImageUploadChanged(event: any) {
    const files: FileList = event.target.files;
  
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileType = file.type.toLowerCase();
  
        // Validate file type
        if (!['image/jpeg', 'image/jpg', 'image/png'].includes(fileType)) {
          console.log('Unsupported file type:', fileType);
          Swal.fire({
            icon: 'warning',
            title: 'Napačen format slike',
            text: 'Podprti formati slik so JPG, JPEG in PNG. Prosimo, poskusite znova.',
          });
          continue;
        }
  
        // Compress the image before adding it
        this.organisationService.compressImage(file, 70, 70).then((compressedFile) => {
          this.imageFiles.push(compressedFile);
          this.previewImageSrcs.push(URL.createObjectURL(compressedFile));
        }).catch(error => {
          console.error('Error compressing image:', error);
        });
      }
    }
  }

removeImage(index: number): void {
  // Remove the file from the imageFiles array
  this.imageFiles.splice(index, 1);

  // Remove the corresponding preview URL
  this.previewImageSrcs.splice(index, 1);
}
cancel() {
  this.activeModal.dismiss('cancel');
}
}
